// extracted by mini-css-extract-plugin
export var formContainer = "_cx-0";
export var message = "_cx-1";